import PageTitle from "@component/PageTitle";
import { createVendor } from "@redux/vendorSlice";
import { message } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store";
import styled from "styled-components";
import useMemberInfo from "@hooks/useMemberInfo";
import VendorDetails from "./VendorDetails";
import { CreateVendorPayload } from "./interface";

const StyledSection = styled.section`
  margin: 12px 16px 162px 12px;
  padding: 13px 22px;
  border: 1px solid #e5e5e5;
`;

export default function NewVendorPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userId } = useMemberInfo();

  const handleFinish = async (values: CreateVendorPayload) => {
    if (!userId) {
      message.error("無法取得使用者資訊，請重新整理後再試");
      return;
    }
    try {
      const result = await dispatch(createVendor({ ...values, owner: userId })).unwrap();
      message.success("申請單建立成功");
      navigate(`/vendor/info/${result.id}`);
    } catch (e) {
      // CoreAPI interceptor 已統一顯示錯誤訊息
    }
  };

  return (
    <StyledSection>
      <PageTitle title="廠商資訊 - 新增" />
      <VendorDetails onFinish={handleFinish} />
    </StyledSection>
  );
}
